<template>
    <div class="col-xs-12">
        <div v-show="!layout.emailSaved" id="emailLead">
            <h2>{{$t('components.emailcapturebox.header')}}</h2>
            <p v-html="$t('components.emailcapturebox.body')"></p>
            <div class="user-input-wrp">
                <b-form-input type="email" id="email" v-model="email" required></b-form-input>
                <span class="floating-label">{{$t('globals.email')}}</span>
                <span v-if="errLabelText.length > 0" class="floating-errLabel">{{errLabelText}}</span>
            </div>
            <div class="col-xs-12 text-center" style="margin-top:20px">
                <b-button variant="primary" size="large" v-if="!layout.savingEmail" class="btn rounded-pill font-weight-bold d-flex justify-content-center align-items-center position-relative btn-block btn-primary" @click="notifyUser">{{$t('components.emailcapturebox.getPicture')}}</b-button>
                <div v-if="layout.savingEmail" style="margin-top: 40%;">
                    <img class="responsive" src="../assets/ms_loading_white.svg" style="max-width: 100px;">
                    <p>
                        <strong>{{$t('globals.saving')}}</strong>
                    </p>
                </div>
                <div style="padding-top: 11px;">
                    <p style="font-size: 12px; font-family: Arial; margin-bottom: 0;">{{$t('components.emailcapturebox.privatePolicyDesc')}}</p>
                    <a style="font-size:12px; font-family: Arial Black; text-decoration: none; color:white;" :href="$t('components.emailcapturebox.privatePolicyUrl')">{{$t('components.emailcapturebox.privatePolicy')}}</a>
                </div>
            </div>
        </div>
        <div v-show="layout.emailSaved">
            <h2>{{$t('components.emailcapturebox.confirmationHeader')}}</h2>
            <p v-html="$t('components.emailcapturebox.confirmationBody')"></p>
        </div>
    </div>
</template>

<script>
    import { validateEmail } from "@/GeneralMethods";
    import APIService from "@/services/APIService";
    import Cookies from 'js-cookie'

    export default {
        name: "EmailCaptureBox",
        data() {
            return {
                email: "",
                errLabelText: "",
                layout: {
                    emailSaved: false,
                    savingEmail: false
                }
            }
        },
        computed: {
            checksum() {
                return this.$route.query.checksum;
            }
        },
        created() {
            var cookieFromEmail = Cookies.get('mys_email');

            if (cookieFromEmail) this.email = cookieFromEmail;
        },
        methods: {
            async notifyUser() {
                if (this.email.length === 0) {
                    this.errLabelText = this.$t('components.emailcapturebox.emailEmptyLabel');
                    return;
                }
                else if (!validateEmail(this.email)) {
                    this.errLabelText = this.$t('components.emailcapturebox.emailErrorLabel');
                    return;
                } else {
                    this.errLabelText = '';
                }

                const params = this.$route.params;
                this.layout.savingEmail = true;

                const response = await APIService.POST(`/sharing/notification/${params.domain}/${params.order}/${params.file}/${params.type}/${params.onedaybutton}/${params.connectionState}/${this.checksum}`, {
                    Email: this.email,
                    Permission: true
                })
                if (!response.ok) {
                    this.layout.savingEmail = false;
                } else {
                    Cookies.set("mys_email", this.email, { secure: true, sameSite: 'Strict', expires: 14 });
                    this.layout.savingEmail = false;
                    this.layout.emailSaved = true;
                    this.email = "";
                }
            }
        }
    }
</script>

<style scoped>

    input {
        border-radius: 20px;
        padding: 20px;
    }

    #email {
        height: 70px;
    }

    #emailLead {
        text-align: left;
        /*padding-left:10px;*/
        /*padding-right:10px;*/
    }

    .user-input-wrp {
        position: relative;
    }

        .user-input-wrp .inputText {
            width: 100%;
            outline: none;
            border: none;
            border-bottom: 1px solid #777;
            box-shadow: none !important;
        }

            .user-input-wrp .inputText:focus {
                border-color: blue;
                border-width: medium medium 2px;
            }

        .user-input-wrp .floating-label {
            color: #B0A9B4;
            position: absolute;
            pointer-events: none;
            top: 22px;
            left: 20px;
            transition: 0.2s ease all;
        }

        .user-input-wrp input:focus ~ .floating-label,
        .user-input-wrp input:not(:focus):valid ~ .floating-label {
            top: 5px;
            left: 20px;
            font-size: 13px;
            opacity: 1;
        }

        .user-input-wrp .floating-errLabel {
            color: red;
            position: absolute;
            pointer-events: none;
            top: 48px;
            left: 20px;
            transition: 0.2s ease all;
            font-size: 13px;
            opacity: 1;
        }

        .user-input-wrp textarea:hover,
        input:hover,
        textarea:active,
        input:active,
        textarea:focus,
        input:focus,
        button:focus,
        button:active,
        button:hover,
        label:focus,
        .btn:active,
        .btn.active {
            outline: 0px !important;
            -webkit-appearance: none;
            box-shadow: none !important;
        }
</style>